import React from 'react';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../../shared/form-elements/input';
import ModalBox from '../../../shared/modal';

const Form = props => (
	<form
		onSubmit={props.handleSubmit(data => {
			props.updateComment({...props.commentFormInitialData, ...data});
		})}
	>
		<div className="control-bar-container">
			<div className='banners-publication-editor-field'>
				<Field
					name='comment'
					component={InputField}
					placeholder={props.intl('Comment')}
				/>
			</div>
		</div>
		<button type="submit" className="ui-btn ui-btn-primary save margin-top-15">
			{props.intl('Update')}
		</button>
		<button
			type="button"
			className="ui-btn ui-btn-cancel margin-top-15 margin-left-5"
			onClick={(e) => {
				e.stopPropagation();
				props.setActiveRow(null);
			}}
		>
			{props.intl('Close')}
		</button>
	</form>
);

const Main = props => (
	<ModalBox
		title={props.intl('Update comment')}
		body={Form(props)}
		isOpen={props.isCommentPopupVisible}
		className="form-modal"
		onClose={props.toggleCommentPopup}
	/>
);

export default reduxForm({
	enableReinitialize: true, form: `conversions_garant_approve_requests_comment`
})(Main);




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/conversions-garant-approve-requests/components/forms/update-comment.js